<script setup lang="ts">
import { getStatusColor, getStatusLabel } from 'ui/components/renters/statusFunctions';
import type { RentersPolicyStatusType } from 'ui/components/renters/enums';

defineProps<{ status: RentersPolicyStatusType; }>();
defineEmits<{ onError: [] }>();
</script>

<template>
  <div class="flex gap-1">
    <div>
      <UiChip
        :color="getStatusColor(status, () => $emit('onError'))"
        size="sm"
      />
    </div>
    <span class="text-xs capitalize">
      {{ getStatusLabel(status, () => $emit('onError')) }}
    </span>
  </div>
</template>
